var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTranslationMemoryDelete = function SvgTranslationMemoryDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 120,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#translation_memory_delete_svg__a)",
    fillRule: "evenodd",
    d: "M41.333 8C21.267 8 5 24.267 5 44.333v12.111c0 15.495 9.7 28.724 23.357 33.948v18.194c0 2.097 2.516 3.147 3.987 1.664l17.338-17.472h27.985C97.733 92.778 114 76.51 114 56.444V44.334C114 24.267 97.733 8 77.667 8H41.333Z",
    clipRule: "evenodd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#translation_memory_delete_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M41.009 52.75c-.1-.775-.174-1.562-.174-2.361 0-.8.074-1.587.174-2.362l-5.265-4.009a1.186 1.186 0 0 1-.3-1.55l4.98-8.393c.311-.52.958-.739 1.519-.52l6.198 2.434a19.025 19.025 0 0 1 4.208-2.386l.933-6.419a1.271 1.271 0 0 1 1.245-1.017h9.958c.623 0 1.133.448 1.233 1.017l.933 6.419a18.55 18.55 0 0 1 4.207 2.386l6.2-2.435c.56-.206 1.207 0 1.518.521l4.98 8.393c.31.521.173 1.175-.3 1.55l-5.253 4.01c.1.774.175 1.562.175 2.36 0 .8-.075 1.587-.175 2.363l5.253 4.008c.473.364.61 1.018.3 1.55l-4.98 8.394c-.311.52-.958.738-1.519.52l-6.199-2.434a19.02 19.02 0 0 1-4.207 2.386l-.933 6.419c-.1.569-.61 1.017-1.233 1.017h-9.958a1.247 1.247 0 0 1-1.232-1.017l-.934-6.42a18.55 18.55 0 0 1-4.207-2.385l-6.199 2.434c-.56.206-1.207 0-1.519-.52l-4.979-8.394a1.191 1.191 0 0 1 .299-1.55l5.253-4.008Zm18.497 6.117c4.817 0 8.713-3.791 8.713-8.478 0-4.687-3.896-8.478-8.713-8.478-4.817 0-8.713 3.79-8.713 8.478 0 4.687 3.896 8.478 8.713 8.478Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    filter: "url(#translation_memory_delete_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#translation_memory_delete_svg__d)",
    d: "M79.5 87c0-9.113 7.387-16.5 16.5-16.5s16.5 7.387 16.5 16.5-7.387 16.5-16.5 16.5S79.5 96.113 79.5 87Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M89.204 80.204a1.833 1.833 0 0 1 2.593 0l11 11a1.833 1.833 0 1 1-2.593 2.593l-11-11a1.833 1.833 0 0 1 0-2.593Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M102.796 80.204a1.834 1.834 0 0 0-2.593 0l-11 11a1.834 1.834 0 0 0 2.593 2.593l11-11a1.833 1.833 0 0 0 0-2.593Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "translation_memory_delete_svg__a",
    x1: 59.5,
    x2: 59.5,
    y1: 8,
    y2: 110.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7BB3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#578AC3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "translation_memory_delete_svg__d",
    x1: 96,
    x2: 96,
    y1: 70.5,
    y2: 103.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F65050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E24848"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "translation_memory_delete_svg__b",
    width: 66.611,
    height: 66.611,
    x: 26.195,
    y: 20.717,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.633
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.542
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1579_17391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1579_17391",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "translation_memory_delete_svg__c",
    width: 60,
    height: 60,
    x: 66,
    y: 59,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.139561 0 0 0 0 0.35972 0 0 0 0 0.566537 0 0 0 0.17 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1579_17391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1579_17391",
    result: "shape"
  })))));
};
export default SvgTranslationMemoryDelete;